import {
  getBaseRequestConfig,
  LOCAL_HLF_FRONTEND_URL,
} from './baseRequestConfig';
import httpRequest from './httpRequest';

export function getSwishQRCode(message) {
  const baseRequestConfig = {
    ...getBaseRequestConfig(),
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'arraybuffer',
  };
  const url = `${LOCAL_HLF_FRONTEND_URL}/api/SwishQRCode`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
    params: {
      size: 300,
      message,
      border: false,
      color: true,
    },
  });

  return httpRequest(requestConfig);
}

export function addNEIOrder(orderObject) {
  const baseRequestConfig = {
    ...getBaseRequestConfig(),
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const url = `${LOCAL_HLF_FRONTEND_URL}/api/NEIOrder/Add`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: orderObject,
  });

  return httpRequest(requestConfig);
}
